import { EventMeta } from '../../../interfaces/meta.interface';

const RemoveInboxRule: EventMeta<any> = {
    title: 'Inbox Rule Removed',
    default: {
        description: 'Inbox Rule Removed',
        longDescription: 'An inbox rule has been deleted.',
        severity: 'info',
    },
    classifications: [
        {
            severity: 'critical',
            description: (fields) => `A suspicious IP attempted to remove an inbox rule`,
            longDescription: (fields) =>
                `An inbox rule was deleted from a mailbox by a suspicious IP address that is not in your allowed list. This activity could indicate an attempt to manipulate or bypass mailbox rules.`,
            predicates: {
                isAllowedASN: false,
                isAllowedCountry: false,
                isAllowedRegion: false,
                isAllowedIP: false,
                isFraudulentIP: true,
                isMicrosoftActivity: false,
            },
        },
        {
            severity: 'danger',
            description: (fields) => `An unapproved IP attempted to remove an inbox rule`,
            longDescription: (fields) =>
                `An inbox rule was deleted from a mailbox by an IP address that is not in your allowed list. This activity may indicate an attempt to alter mailbox behavior or bypass email rules.`,
            predicates: {
                isAllowedASN: false,
                isAllowedCountry: false,
                isAllowedRegion: false,
                isAllowedIP: false,
                isMicrosoftActivity: false,
            },
        },
        {
            severity: 'warning',
            description: (fields) => `A suspicious IP removed an inbox rule`,
            longDescription: (fields) =>
                `An inbox rule was deleted. The action originated from a suspicious IP. While users or admins may legitimately remove inbox rules, doing so from a suspicious IP is unusual and may indicate tampering with mail handling. Review the change to confirm whether it was expected or potentially unauthorized.`,
            predicates: {
                isFraudulentIP: true,
                isMicrosoftActivity: false,
            },
        },
        {
            severity: 'info',
            description: (fields) => `A Microsoft system operation (synchronization server IP) removed an inbox rule`,
            longDescription: (fields) =>
                `An inbox rule was deleted. This was recorded as a Microsoft system operation event, with the IP address associated with the Microsoft server responsible for handling synchronization. This entry is informational and reflects expected background activity. No action is required unless inbox rule removals appear inconsistent with normal system behaviour or your configuration policies.`,
            predicates: {
                isMicrosoftActivity: true,
            },
        },
        {
            severity: 'info',
            description: (fields) => `An inbox rule was deleted`,
            longDescription: (fields) =>
                `An inbox rule was deleted. This is an informational record of a mailbox configuration change. No unusual conditions were associated with this event. It does not require immediate action unless the removal of the inbox rule was unexpected.`,
        },
    ],
};

export default RemoveInboxRule;
